import { render, staticRenderFns } from "./ModalForms.vue?vue&type=template&id=3287277c&scoped=true&"
import script from "./ModalForms.vue?vue&type=script&lang=js&"
export * from "./ModalForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3287277c",
  null
  
)

export default component.exports